// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"ad88f1ab","455":"e1b8526e","469":"0d266daf","923":"669b7575","977":"94205b7f"}[chunkId] + ".chunk.js";
};